<div class="fixed inset-0 z-50" aria-labelledby="quickbook-slide-over-title" role="dialog" aria-modal="true">
    <!-- Background Overlay -->
    <div class="fixed inset-0 bg-zinc-950/25 dark:bg-zinc-950/50 backdrop-blur-sm transition-opacity" (click)="onCloseModal()"
        aria-hidden="true"></div>

    <!-- Slide-over Panel -->
    <div class="fixed inset-y-0 right-0 flex max-w-full py-4 pr-4 pl-4 sm:pl-8">
        <div class="w-screen max-w-md">
            <div
                class="flex h-full flex-col overflow-hidden rounded-lg border border-zinc-950/10 bg-white shadow-xl dark:border-white/10 dark:bg-zinc-950">

                <!-- Header -->
                <div
                    class="flex items-center justify-between gap-3 border-b border-zinc-950/10 px-4 py-3 dark:border-white/10">
                    <div class="flex items-center gap-2">
                        <h3 class="text-base font-semibold text-zinc-950 dark:text-white" id="quickbook-slide-over-title">
                            QuickBooks Notifications</h3>
                        <span *ngIf="unreadCount > 0" class="badge-secondary">
                            {{ unreadCount }} unread
                        </span>
                    </div>
                    <div class="flex items-center gap-3">
                        <button *ngIf="unreadCount > 0 || hasUnreadNotifications()"
                            type="button"
                            (click)="onMarkAllAsRead()"
                            class="text-xs font-medium text-zinc-600 hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-zinc-200 hover:underline cursor-pointer transition-colors">
                            Mark all as read
                        </button>
                        <button type="button" (click)="onCloseModal()"
                            class="rounded-lg p-1.5 text-zinc-500 hover:bg-zinc-950/5 hover:text-zinc-950 dark:text-zinc-400 dark:hover:bg-white/5 dark:hover:text-white">
                            <span class="sr-only">Close panel</span>
                            <svg class="size-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>

                <!-- List -->
                <div class="flex-1 overflow-y-auto">
                    <div *ngIf="!notifications.length" class="p-8">
                        <div
                            class="relative block w-full rounded-lg border-2 border-dashed border-zinc-950/10 dark:border-white/10 p-12 text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="mx-auto h-12 w-12 text-zinc-400 dark:text-zinc-500">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M3 8.25V18a2.25 2.25 0 002.25 2.25h13.5A2.25 2.25 0 0021 18V8.25m-18 0V6a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 6v2.25m-18 0h18M5.25 6h.008v.008H5.25V6zM7.5 6h.008v.008H7.5V6zm2.25 0h.008v.008H9.75V6z" />
                            </svg>
                            <span class="mt-2 block font-medium text-zinc-500 dark:text-zinc-400">No notifications to
                                show</span>
                        </div>
                    </div>

                    <ul *ngIf="notifications.length" role="list" class="space-y-2 p-3">
                        <li *ngFor="let notification of notifications; trackBy: trackById">
                            <button type="button" (click)="onNotificationClick(notification)"
                                class="flex w-full items-start gap-3 rounded-lg border p-3 text-left transition-all duration-150 hover:shadow-sm"
                                [ngClass]="notification.isRead
                                    ? 'border-zinc-200/80 bg-zinc-50/50 hover:bg-zinc-100/70 dark:border-zinc-800/80 dark:bg-zinc-900/40 dark:hover:bg-zinc-900/80'
                                    : 'border-l-4 border-l-zinc-400 border-zinc-300/80 bg-zinc-100/70 hover:bg-zinc-200/70 shadow-sm dark:border-l-zinc-500 dark:border-zinc-700/80 dark:bg-zinc-800/60 dark:hover:bg-zinc-800/90'">
                                <div class="min-w-0 flex-1">
                                    <div class="flex items-start justify-between gap-2">
                                        <div class="flex items-center gap-1.5 min-w-0">
                                            <p class="truncate text-sm"
                                                [ngClass]="notification.isRead ? 'font-medium text-zinc-600 dark:text-zinc-400' : 'font-semibold text-zinc-950 dark:text-white'">
                                                {{ notification?.title | titlecase }}
                                            </p>
                                        </div>
                                        <div class="flex items-center gap-1.5 shrink-0">
                                            <span *ngIf="!notification.isRead"
                                                class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold bg-zinc-100 text-zinc-700 dark:bg-zinc-700 dark:text-zinc-200">
                                                <span class="size-1.5 rounded-full bg-zinc-600 dark:bg-zinc-400"></span>
                                                New
                                            </span>
                                            <span *ngIf="notification.isRead"
                                                class="inline-flex items-center text-[10px] font-medium text-zinc-400 dark:text-zinc-500">
                                                Read
                                            </span>
                                        </div>
                                    </div>
                                    <p class="mt-1 line-clamp-2 text-xs"
                                        [ngClass]="notification.isRead ? 'text-zinc-500 dark:text-zinc-400' : 'text-zinc-700 dark:text-zinc-200 font-medium'">
                                        {{ notification.message }}
                                    </p>
                                    <div class="mt-2 flex items-center gap-2">
                                        <span class="text-[11px]"
                                            [ngClass]="notification.isRead ? 'text-zinc-400 dark:text-zinc-500' : 'text-zinc-600 dark:text-zinc-400 font-medium'">
                                            {{ getRelativeTime(notification.createdAt) }}
                                        </span>
                                        <span *ngIf="notification.company?.CompanyName" class="badge-secondary">
                                            {{ notification.company.CompanyName }}
                                        </span>
                                    </div>
                                </div>
                            </button>
                        </li>
                    </ul>
                </div>

                <!-- Footer -->
                <div class="border-t border-zinc-950/10 px-4 py-3 dark:border-white/10">
                    <button [routerLink]="['/quickbook/notifications']" (click)="closeModal.emit()" class="btn btn-secondary w-full">
                        All Notifications
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
